/**
 * 诊断事件的 URL 脱敏。产品区 URL 会带 chat_id、邀请码、OAuth code 等，
 * SDK 在发送前才补齐 URL，所以必须在 beforeSend 这个最终边界清理：
 * 去掉 query、hash 与凭据，只保留能定位页面的 origin + path。
 */
interface DiagnosticUrlFields {
    view?: { url?: string; referrer?: string };
    http?: { url?: string };
    resource?: { url?: string };
    error?: unknown;
}

export function redactUrl(value: string): string {
    if (!value) return value;
    try {
        const url = new URL(value);
        url.username = '';
        url.password = '';
        url.search = '';
        url.hash = '';
        return url.href;
    } catch {
        // 解析失败的值无法确认是否含敏感信息，整体丢弃。
        return '';
    }
}

export function redactDiagnosticUrls(event: DiagnosticUrlFields): void {
    for (const field of [event.view, event.http, event.resource]) {
        if (field && typeof field.url === 'string') field.url = redactUrl(field.url);
    }
    if (typeof event.view?.referrer === 'string') event.view.referrer = redactUrl(event.view.referrer);
    const resource = event.error && typeof event.error === 'object' && 'resource' in event.error
        ? (event.error as { resource?: unknown }).resource
        : undefined;
    if (resource && typeof resource === 'object' && 'url' in resource && typeof (resource as { url: unknown }).url === 'string') {
        (resource as { url: string }).url = redactUrl((resource as { url: string }).url);
    }
}
